module.exports = __webpack_public_path__ + "img/img1.a2e4ae6b.jpg";